export default defineNuxtPlugin(() => {
  if (import.meta.browser || document) {
    const originalConsoleError = console.error
    console.error = function (...args) {
      // Suppress the hydration warning
      if (
        args &&
        args[0] &&
        args[0].includes &&
        `${args[0]}`.includes('Hydration completed but contains mismatches')
      ) {
        return
      }
      originalConsoleError.apply(console, args)
    }
  }
})
